import React, { Fragment, useState } from 'react';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import TextField from '@material-ui/core/TextField';
import ReactDragListView from 'react-drag-listview';

const CreateQuestion = (props) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const { idx, field, deleteQuestion, handleQuestionChange, handleAddChoice, label, handleGroupAddQuestion,
        handleGroupAddExistingQuestion, deleteGroupQuestion, isGroupItem, fieldIdx, handleGroupAddChoice, handleDragEnd,
        questionView, handleDeleteChoice, fields, fieldsLength, handleFieldPositionChange, disabled, disableRef } = props;

    function handleChange(value, path) {
        if (!questionView && isGroupItem) {
            let groupPath = `properties.fields[${idx}].${path}`;
            handleQuestionChange(value, fieldIdx, groupPath, idx);
        } else if (!questionView) {
            handleQuestionChange(value, idx, path);
        } else if (isGroupItem) {
            let groupPath = `properties.fields[${idx}].${path}`;
            handleQuestionChange(value, groupPath, idx);
        } else {
            handleQuestionChange(value, path);
        }
    }

    function handleDelete() {
        if (!questionView && isGroupItem) {
            deleteQuestion(fieldIdx, idx);
        } else if (!questionView) {
            deleteQuestion(idx);
        } else if (isGroupItem) {
            deleteQuestion(idx);
        }
    }

    function addChoice() {
        if (!questionView && isGroupItem) {
            handleAddChoice(fieldIdx, idx);
        } else if (!questionView) {
            handleAddChoice(idx);
        } else if (isGroupItem) {
            handleAddChoice(idx);
        } else {
            handleAddChoice();
        }
    }

    function onDragEnd(fromIndex, toIndex){
        if(disabled) return;
        if(isGroupItem){
            handleDragEnd(fromIndex, toIndex, idx);
        }else{
            handleDragEnd(fromIndex, toIndex);
        }
    }

    function handleKeyDown(event, label, choiceIdx) {
        if (event.keyCode === 8 && label === "") {
            if (!questionView && isGroupItem) {
                handleDeleteChoice(fieldIdx, choiceIdx, idx);
            } else if (!questionView) {
                handleDeleteChoice(idx, choiceIdx);
            } else if (isGroupItem) {
                handleDeleteChoice(choiceIdx, idx);
            } else {
                handleDeleteChoice(choiceIdx);
            }
        }
    }

    function handleMenuItemClick(event, newPosition) {
        if (newPosition !== idx) {
            handleFieldPositionChange(idx, newPosition);
        }
        setAnchorEl(null);
    }

    function handleClick(event) {
        setAnchorEl(event.currentTarget);
    };

    function handleClose() {
        setAnchorEl(null);
    };

    const menuOptions = fillArray(fieldsLength);

    return (
        <div style={{ display: 'flex', padding: 5, margin: 5, position: 'relative', width: '100%' }}>
            <div style={{ display: 'flex', flexDirection: 'column', width: '48%', marginRight: 10 }}>
                {(!questionView || isGroupItem) &&
                    <Fragment>
                        <h4 aria-controls="simple-menu" aria-haspopup="true" onClick={!isGroupItem ? handleClick : undefined} style={{ marginTop: 0, cursor: isGroupItem ? '' : 'pointer' }}>
                            {label}
                        </h4>
                        {!isGroupItem &&
                            <Menu
                                id="position-menu"
                                anchorEl={anchorEl}
                                keepMounted
                                open={Boolean(anchorEl)}
                                onClose={handleClose}
                                style={{ zIndex: 10 }}
                            >
                                {menuOptions.map((option, menuIdx) => (
                                    <MenuItem
                                        key={option}
                                        selected={menuIdx === idx}
                                        onClick={(event) => handleMenuItemClick(event, menuIdx)}
                                    >
                                        {`${option}. ${fields[menuIdx].ref}`}
                                    </MenuItem>
                                ))}
                            </Menu>
                        }
                    </Fragment>
                }
                <label style={styles["label"]} htmlFor="field-title"> Question Text </label>
                <TextField
                    id="field-title"
                    multiline
                    rowsMax={10}
                    value={field.title}
                    onChange={(e) => handleChange(e.target.value, 'title')}
                    autoComplete="off"
                    disabled={disabled}
                />
                {
                    field.type === 'opinion_scale' &&
                    <Fragment>
                        <label style={styles["label"]} htmlFor="start_one">Start at 1?</label>
                        <select id="start-one" value={field.properties.start_at_one} onChange={(e) => {
                            if (e.target.value === 'false' || e.target.value === false) {
                                handleChange(false, 'properties.start_at_one');
                            } else {
                                handleChange(true, 'properties.start_at_one');
                            }
                        }} style={styles["select"]} disabled={disabled}>
                            <option value={false}> False </option>
                            <option value={true}> True </option>
                        </select>
                        <label style={styles["label"]} htmlFor="scale_steps">Number of steps</label>
                        <select id="scale_steps" value={field.properties.steps} onChange={(e) => handleChange(parseInt(e.target.value), 'properties.steps')} style={styles["select"]} disabled={disabled}>
                            <option value={11}> 11 </option>
                            <option value={10}> 10 </option>
                            <option value={9}> 9 </option>
                            <option value={8}> 8 </option>
                            <option value={7}> 7 </option>
                            <option value={6}> 6 </option>
                            <option value={5}> 5 </option>
                        </select>
                        <div style={{ width: '100%', display: 'flex' }}>
                            <div style={{ width: '30%', margin: 3 }}>
                                <label style={styles["label"]} htmlFor="scale_left">{isGroupItem ? "Left" : "Left Label"}</label>
                                <input
                                    id="scale_left"
                                    style={{ ...styles["input"], width: '100%', opacity: disabled ? 0.5 : 1 }}
                                    value={field.properties.labels ? field.properties.labels.left : ''}
                                    onChange={(e) => handleChange(e.target.value, 'properties.labels.left')}
                                    autoComplete="off"
                                    disabled={disabled}
                                />
                            </div>
                            <div style={{ width: '30%', margin: 3 }}>
                                <label style={styles["label"]} htmlFor="scale_center">{isGroupItem ? "Center" : "Center Label"}</label>
                                <input
                                    id="scale_center"
                                    style={{ ...styles["input"], width: '100%', opacity: disabled ? 0.5 : 1 }}
                                    value={field.properties.labels ? field.properties.labels.center : ''}
                                    onChange={(e) => handleChange(e.target.value, 'properties.labels.center')}
                                    autoComplete="off"
                                    disabled={disabled}
                                />
                            </div>
                            <div style={{ width: '30%', margin: 3 }}>
                                <label style={styles["label"]} htmlFor="scale_right">{isGroupItem ? "Right" : "Right Label"}</label>
                                <input
                                    id="scale_right"
                                    style={{ ...styles["input"], width: '100%', opacity: disabled ? 0.5 : 1 }}
                                    value={field.properties.labels ? field.properties.labels.right : ''}
                                    onChange={(e) => handleChange(e.target.value, 'properties.labels.right')}
                                    autoComplete="off"
                                    disabled={disabled}
                                />
                            </div>
                        </div>
                    </Fragment>
                }
                {field.type === 'group' &&
                    <Fragment>
                        {field.properties.fields &&
                            <Fragment>
                                {field.properties.fields.map((groupField, groupIdx) => {
                                    let groupLabel = `${String.fromCharCode(97 + groupIdx)}.`
                                    if (idx || idx === 0) {
                                        groupLabel = (idx + 1) + groupLabel;
                                    }
                                    return (
                                        <CreateQuestion
                                            key={groupIdx}
                                            fieldIdx={idx}
                                            field={groupField}
                                            idx={groupIdx}
                                            handleQuestionChange={handleQuestionChange}
                                            handleAddChoice={handleGroupAddChoice}
                                            handleDeleteChoice={handleDeleteChoice}
                                            deleteQuestion={deleteGroupQuestion}
                                            label={groupLabel}
                                            isGroupItem={true}
                                            questionView={questionView}
                                            disabled={disabled}
                                            handleDragEnd={handleDragEnd}
                                        />
                                    )
                                })}
                                <div style={{ display: 'flex' }}>
                                    <button style={{ ...styles['button'], opacity: disabled ? 0.5 : 1 }} onClick={() => handleGroupAddQuestion(idx)} disabled={disabled}>Add new question to group</button>
                                    <button style={{ ...styles['button'], opacity: disabled ? 0.5 : 1 }} onClick={() => handleGroupAddExistingQuestion(idx)} disabled={disabled}>Add existing question to group</button>
                                </div>
                            </Fragment>
                        }
                    </Fragment>
                }
                {
                    (field.type === 'multiple_choice') &&
                    <div style={{ display: 'flex', flexDirection: 'column' }}>

                        <label style={styles["label"]} htmlFor="allow-multi">Allow Multiple Selection</label>
                        <input
                            id="allow-multi"
                            type="checkbox"
                            name="Multiple Selection"
                            checked={field.properties.allow_multiple_selection}
                            onChange={(e) => handleChange(!field.properties.allow_multiple_selection, "properties.allow_multiple_selection")}
                            style={{ height: 20, width: 20, marginLeft: 15 }}
                            disabled={disabled}
                        />
                        <label style={styles["label"]} htmlFor="allow-other">Allow Other Choice</label>
                        <input
                            id="allow-other"
                            type="checkbox"
                            name="Other Choice"
                            checked={field.properties.allow_other_choice}
                            onChange={(e) => handleChange(!field.properties.allow_other_choice, "properties.allow_other_choice")}
                            style={{ height: 20, width: 20, marginLeft: 15 }}
                            disabled={disabled}
                        />
                        {field.properties.choices &&
                            <ReactDragListView nodeSelector="div" handleSelector="label" onDragEnd={onDragEnd}>
                                {field.properties.choices.map((choice, choiceIdx) => (
                                    <div key={choiceIdx}>
                                        <label style={styles["label"]}>{"Choice " + (choiceIdx + 1)} </label>
                                        <input
                                            style={{ ...styles["input"], opacity: disabled ? 0.5 : 1 }}
                                            value={choice.label}
                                            onChange={(e) => handleChange(e.target.value, `properties.choices[${choiceIdx}].label`)}
                                            onKeyDown={(e) => handleKeyDown(e, choice.label, choiceIdx)}
                                            autoComplete="off"
                                            disabled={disabled}
                                        />
                                    </div>
                                ))}
                            </ReactDragListView>
                        }
                        <button style={{ ...styles["button"], opacity: disabled ? 0.5 : 1 }} onClick={addChoice} disabled={disabled}> Add Choice </button>
                    </div>
                }
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', width: '48%' }}>
                {(!questionView || isGroupItem) &&
                    <Fragment>
                        <h4 style={{ marginTop: 0 }}> Details </h4>
                        <IconButton style={{ position: 'absolute', right: 20 }} onClick={handleDelete} disabled={(disabled && isGroupItem)}>
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    </Fragment>
                }
                <label style={styles["label"]} htmlFor="field-ref">Question Ref</label>
                <input
                    id="field-ref"
                    style={{ ...styles["input"], opacity: disabled ? 0.5 : 1 }}
                    value={field.ref}
                    onChange={(e) => handleChange(e.target.value, 'ref')}
                    autoComplete="off"
                    disabled={disabled || disableRef}
                />
                <label style={styles["label"]} htmlFor="field-desc">Description</label>
                <input
                    id="field-desc"
                    style={{ ...styles["input"], opacity: disabled ? 0.5 : 1 }}
                    value={field.properties.description ? field.properties.description : ''}
                    onChange={(e) => handleChange(e.target.value, 'properties.description')}
                    autoComplete="off"
                    disabled={disabled}
                />
                {(requiredValidation.includes(field.type) && (!questionView)) &&
                    <Fragment>
                        <label style={styles["label"]} htmlFor="field-required">Required</label>
                        <input
                            id="field-required"
                            type="checkbox"
                            name="Required"
                            checked={field.validations ? field.validations.required : false}
                            onChange={() => handleChange(!field.validations.required, 'validations.required')}
                            style={{ height: 20, width: 20, marginLeft: 15 }}
                            disabled={disabled}
                        />
                    </Fragment>
                }
                <select value={field.type} onChange={(e) => handleChange(e.target.value, 'type')} style={styles["select"]} disabled={disabled}>
                    {questionTypes.map(type => {
                        if (!isGroupItem || type.value !== 'group') {
                            return (
                                <option key={type.value} value={type.value}> {type.label} </option>
                            )
                        } else {
                            return null;
                        }
                    })}
                </select>
            </div>
        </div>
    )
};

function fillArray(length) {
    if (!length) return null;
    let arr = [];
    while (length > 0) {
        arr.unshift(length);
        length--;
    }
    return arr;
}

const styles = {
    'input': {
        backgroundColor: 'white',
        border: 'none',
        borderBottom: '2px solid #B8D0EF',
        outline: 'none',
        width: '100%',
        fontSize: 1 + "rem",
        fontWeight: 'regular',
        lineHeight: 1.6,
        marginBottom: 15,
        boxShadow: 'none',
        boxSizing: 'border-box',
        borderRadius: "4px 4px 0 0",
    },
    'select': {
        fontSize: 16,
        width: '60%',
        margin: 5,
        height: 40
    },
    'label': {
        fontSize: 14,
        marginBottom: 0,
        textTransform: 'capitalize',
        color: '#0256c5',
        paddingLeft: 1 + "rem"
    },
    'button': {
        backgroundColor: '#f0a34e',
        color: 'white',
        cursor: 'pointer',
        borderRadius: 8,
        fontSize: 12,
        padding: 8,
        margin: 10,
        width: '50%',
    }
}

const requiredValidation = [
    'email',
    'long_text',
    'short_text',
    'multiple_choice',
    'opinion_scale',
    'phone_number',
    'yes_no'
]

const questionTypes = [
    { label: 'Yes/No', value: 'yes_no' },
    { label: 'Opinion scale', value: 'opinion_scale' },
    { label: 'Multiple choice', value: 'multiple_choice' },
    { label: 'Short text', value: 'short_text' },
    { label: 'Long text', value: 'long_text' },
    { label: 'Email', value: 'email' },
    { label: 'Group', value: 'group' },
    { label: 'Statement', value: 'statement' }
]

export default CreateQuestion;